import dayjs from "dayjs";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { CLEAR_TABS, SET_FILTER } from "_common/actions/_types";

export const NAME = "SUMMARY_CANCELLATION";

const initialState = {
  filters: {
    start_at: dayjs().subtract(7, "days").toDate(),
    end_at: dayjs().toDate(),
  },
};

const persistConfig = {
  key: "_summary_cancellation",
  storage: storage,
  blacklist: ["code"],
  migrate: (object, number) => {
    return new Promise((res, rej) =>
      object
        ? res({
            ...object,
            filters: {
              ...object.filters,
              start_at: dayjs(object.filters.start_at).toDate(),
              end_at: dayjs(object.filters.end_at).toDate(),
            },
          })
        : res(object),
    );
  },
};

function summaryCancellationReducer(
  state = initialState,
  { type, payload } = { type: null, payload: null },
) {
  switch (type) {
    case SET_FILTER:
      if (payload.component === NAME)
        return { ...state, filters: payload.filters };
    case CLEAR_TABS:
      if (payload.component === NAME || payload === "ALL")
        return {
          ...state,
          filters: {
            start_at: dayjs().subtract(7, "days").toDate(),
            end_at: dayjs().toDate(),
          },
        };
    default:
      return state;
  }
}

export default persistReducer(persistConfig, summaryCancellationReducer);
